import { Anchor, Button, Center, Group, Loader, Paper, Stack, Text, ThemeIcon, Title } from '@mantine/core';
import { IconArrowLeft, IconDeviceMobile, IconLock } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router';
import { appConfig, currentUser, loginAdmin, tokenAcr } from '../lib/auth';

const ACTIVITY = ['mousemove', 'keydown', 'pointerdown', 'scroll', 'touchstart'] as const;

// Вход в админку только со вторым фактором; 30 минут без действий - повторный вход (AUTH-03).
// Сервер проверяет то же самое на каждом запросе, здесь - чтобы не показывать экран, который всё равно откажет.
export function AdminGate() {
  const [state, setState] = useState<'checking' | 'ok' | 'idle' | 'need-code'>('checking');
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    currentUser().then((u) => {
      if (tokenAcr(u) === appConfig().adminAcr) setState('ok');
      // без предупреждения редирект на страницу кода Keycloak выглядит как «выкинуло из портала»
      else setState('need-code');
    });
  }, [pathname, search]);

  useEffect(() => {
    if (state !== 'ok') return;
    let last = Date.now();
    const mark = () => {
      last = Date.now();
    };
    ACTIVITY.forEach((e) => window.addEventListener(e, mark, { passive: true }));
    const timer = window.setInterval(() => {
      if (Date.now() - last > appConfig().adminIdleMin * 60_000) setState('idle');
    }, 30_000);
    return () => {
      window.clearInterval(timer);
      ACTIVITY.forEach((e) => window.removeEventListener(e, mark));
    };
  }, [state]);

  if (state === 'checking') return <Center py="xl"><Stack align="center"><Loader /><Text size="sm" c="dimmed">Проверка второго фактора…</Text></Stack></Center>;
  if (state === 'need-code') {
    return (
      <Center py="xl">
        <Paper withBorder radius="lg" p="xl" maw={480}>
          <Stack align="center" ta="center">
            <ThemeIcon size={56} radius="xl" variant="light" color="violet"><IconDeviceMobile size={30} /></ThemeIcon>
            <Title order={3}>Раздел команды обучения</Title>
            <Text size="sm">Здесь управляют курсами, назначениями и результатами, поэтому вход защищён вторым фактором.</Text>
            <Text size="sm" c="dimmed">На следующем шаге откроется страница входа компании: введите 6-значный код из приложения-аутентификатора (Google Authenticator, Microsoft Authenticator и т. п.). Код подтверждается раз в {appConfig().adminIdleMin} минут.</Text>
            <Group>
              <Button variant="default" leftSection={<IconArrowLeft size={16} />} onClick={() => navigate('/')}>К обучению</Button>
              <Button color="violet" leftSection={<IconLock size={16} />} onClick={() => loginAdmin(pathname + search)}>Ввести код</Button>
            </Group>
            <Anchor component={Link} to="/help#authenticator" size="xs">Нет кода? Как настроить приложение-аутентификатор</Anchor>
          </Stack>
        </Paper>
      </Center>
    );
  }
  if (state === 'idle') {
    return (
      <Center py="xl">
        <Paper withBorder radius="lg" p="xl" maw={420}>
          <Stack align="center" ta="center">
            <ThemeIcon size={56} radius="xl" variant="light"><IconLock /></ThemeIcon>
            <Title order={3}>Сессия админки закрыта</Title>
            <Text size="sm" c="dimmed">После {appConfig().adminIdleMin} минут без действий нужно войти заново с одноразовым кодом.</Text>
            <Button onClick={() => loginAdmin(pathname + search, true)}>Войти снова</Button>
          </Stack>
        </Paper>
      </Center>
    );
  }
  return <Outlet />;
}
